<div class="modal-header d-flex">
    <div class="modal-title">Key Concepts</div>
    <div type="button" class="gyan-popup-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <div class="modal-close-icon"></div>
    </div>
</div>
<div class="modal-body">
    <div class="key-popup font-14">
        <div class="float-start mt-2 mb-2 col-12">
            <input
                type="text"
                [(ngModel)]="inputValue"
                (keydown.enter)="addKeyConcepts()"
                (input)="sanitizeInput($event)"
                (paste)="onPaste($event)"
                [attr.id]="'add-keyconcept'"
                [attr.data-test]="'add-keyconcept'"
                placeholder="Enter keyconcepts(Keyconcept1, Keyconcept2, etc..,)"
            />
        </div>
        <!-- Plus icon for adding a new subtopic -->
        <div
            *ngIf="inputValue.trim() !== ''"
            class="add-subtopic-icon"
            [attr.id]="'add-keyconcept'"
            [attr.data-test]="'add-keyconcept'"
            (mousedown)="addKeyConcepts()"
            [ngStyle]="{ 'margin-left': '5px', cursor: 'pointer' }"
        >
            <div class="gyan-topic-plus-icon"></div>
        </div>
        <div class="clear"></div>
        <div class="row" *ngIf="keyConcepts.length > 0">
            <div class="col-4 col-sm-6"></div>
            <div class="col-2 col-sm-2 text-center"><span>Search </span></div>
            <div class="col-3 col-sm-2 text-center"><span>Relevance</span></div>
            <div class="col-3 col-sm-2 text-center"><span>Delete</span></div>
        </div>
        <div class="modal-body-continer">
            <div *ngFor="let keyConcept of keyConcepts; let i = index" class="key-concept-item">
                <div class="row">
                    <div class="col-4 col-sm-6">
                        <span>{{ keyConcept.name }}</span>
                    </div>
                    <div class="col-2 col-sm-2 text-center"><input type="checkbox" [(ngModel)]="keyConcept.isSearch" /></div>
                    <div class="col-3 col-sm-2 text-center"><input type="checkbox" [(ngModel)]="keyConcept.isRelevance" /></div>
                    <div class="col-3 col-sm-2 text-center"><div (click)="removeKeyConcept(i)" class="delete-icon margin-auto"></div></div>
                </div>
            </div>
        </div>
        <!-- <button class="btn-custom btn-primary mr-3 mt-4 cursor-pointer col-sm-2 float-end" [ngClass]="prevKeyConcepts.length > 0 ? '' : 'disabled'" (click)="saveKeyConcepts()">
            Save
        </button> -->
    </div>
</div>
<div class="modal-footer border-0" [ngClass]="{ 'key-submit': isMobile }">
    <button
        type="button"
        class="btn-custom btn-primary mr-3 mt-0 cursor-pointer col-sm-2 float-end"
        [attr.id]="'save-keywords'"
        [attr.data-test]="'save-keywords'"
        [ngClass]="prevKeyConcepts.length > 0 ? '' : 'disabled'"
        (click)="saveKeyConcepts()"
    >
        Save
    </button>
</div>
